// ** React Imports
import { Fragment } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// ** Custom Components
import NavbarUser from "./NavbarUser";

import { ChevronDown } from "react-feather";
// ** Third Party Components
import { Sun, Moon, Menu, ArrowRight } from "react-feather";

import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
// ** Reactstrap Imports
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const ThemeNavbar = (props) => {
  const { t } = useTranslation();
  // ** Props
  // Recebendo as props de controle do menu para sabermos quando ele está encolhido e podermos expandir
  const { skin, setSkin, setMenuVisibility, menuCollapsed, setMenuCollapsed } = props; 
  const location = useLocation();
  const navigate = useNavigate();

  const pathParts = location.pathname.split('/');
  const isDashboard = pathParts.includes('dashboard');
  
  // 1. Tenta extrair o domínio da URL (ex: /dashboard/site.com)
  const urlDomain = isDashboard ? pathParts[pathParts.indexOf('dashboard') + 1] || null : null;  
  
  const sites = useSelector((state) => state.userAccount.sites);

  // ==========================================
  // LÓGICA DE PREVISÃO DE DOMÍNIO
  // ==========================================
  let displayDomain = urlDomain;
  
  // Se a URL ainda for SÓ /dashboard, MAS os sites já existirem no Redux...
  // O Header "adivinha" e preenche o primeiro site antes mesmo do redirecionamento acontecer!
  if (!displayDomain && sites && sites.length > 0) {
    displayDomain = sites[0].domain || sites[0].name;
  }

  const ThemeToggler = () => {
    if (skin === "dark") {
      return <Sun className="ficon" onClick={() => setSkin("light")} />;
    } else {
      return <Moon className="ficon" onClick={() => setSkin("dark")} />;
    }
  };

  return (
    <Fragment>
      <div className="navbar-left-wrapper">
        {/* BOTÃO HAMBÚRGUER (Aparece apenas em telas menores que 1200px graças à classe d-xl-none) */}
        <div 
          className="d-xl-none cursor-pointer" 
          onClick={() => setMenuVisibility(true)}
          style={{ color: '#000000ff', margin: "0 8px" }} // Ajuste a cor se necessário para combinar com seu layout
        >
          <Menu size={24} />
        </div>

        {/* NOVA SETA PARA DIREITA (Desktop - Só aparece se o menu estiver recolhido) */}
        {menuCollapsed && (
          <button 
            type="button"
            className="d-none d-xl-flex cursor-pointer align-items-center button-toggle-menu" 
            onClick={() => setMenuCollapsed(false)} 
            aria-label={t('navbar.expandMenu')} 
            aria-expanded="false"
            title={t('navbar.expandMenu')}
            style={{ 
              color: '#000000ff', 
              margin: "0 8px",
              background: "transparent", 
              border: "none",          
              padding: 0,
              borderRadius: "12px",         
            }} 
          >
            <ArrowRight size={20} aria-hidden="true" />
          </button>
        )}
        
        {/* BREADCRUMB */}
        <div className={`navbar-left ${isDashboard ? 'is-dashboard' : ''}`}>

          {isDashboard ? (
            <div className="breadcrumb-home" style={{ cursor: 'default' }}>
              <h1 className="breadcrumb-home-text text-gray">
                {t('navbar.homePage')}
              </h1>
            </div>
          ) : (
            <Link to="/dashboard" className="breadcrumb-home ho-ver">
              <h1 className="breadcrumb-home-text text-black">
                {t('navbar.homePage')}
              </h1>
            </Link>
          )}
          {isDashboard && (
            sites && sites.length === 0 ? (
              <>
                <span className="breadcrumb-divider-text">/</span>
                <span className="breadcrumb-site breadcrumb-site-disabled">
                  <div className="breadcrumb-site-text">
                    <span>{t('navbar.noDomain')}</span>
                  </div>
                </span>
              </>
            ) : displayDomain ? (
              <>
                <span className="breadcrumb-divider-text">/</span>

                <UncontrolledDropdown inNavbar>
                  <DropdownToggle tag="div" className="breadcrumb-site" tabIndex="0">

                    <div className="breadcrumb-site-text">
                      <span>{displayDomain}</span>
                    </div>

                    <div className="breadcrumb-icon-button">
                      <ChevronDown size={16} />
                    </div>

                  </DropdownToggle>

                  <DropdownMenu className="site-dropdown-menu">
                    <div className="site-dropdown-scroll">
                      {sites && sites.map((site, index) => (
                        <DropdownItem
                          key={`${site.domain}-${index}`}
                          onClick={() => navigate(`/dashboard/${site.domain}`)}
                        >
                          {site.domain}
                        </DropdownItem>
                      ))}
                    </div>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </>
            ) : null
          )}
        </div>
      </div>

      <NavbarUser skin={skin} setSkin={setSkin} />
    </Fragment>
  );
};

export default ThemeNavbar;